import visibilityActions from "../actions/visibilityActions";
import { visibilityService } from "../../services/visibilityService";

import { OperationsFactory } from "./ProtectedOperationsFactory";

const fetch = OperationsFactory.createFetchMethod(
  visibilityActions,
  visibilityService.fetch
);

const setFiltered = visibilityActions.fetchSuccess;

const fetchAll = OperationsFactory.createFetchAllMethod(
  visibilityActions,
  visibilityService.fetchAll
);

const fetchAllRoles = OperationsFactory.createFetchAllMethod(
  visibilityActions,
  visibilityService.fetchAllRoles
);

const update = OperationsFactory.createUpdateOrCreateAllMethod(
  visibilityActions,
  visibilityService.update
);

const create = OperationsFactory.createUpdateOrCreateAllMethod(
  visibilityActions,
  visibilityService.create
);

export const visibilityOperations = {
  fetch,
  fetchAll,
  fetchAllRoles,
  setFiltered,
  update,
  create,
};
